import React, { useEffect, useState } from 'react';
import { getNotification } from '../Service/Api';

const Popup = () => {
  const [data, setData] = useState([]);
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const modalData = await getNotification();
        if (modalData?.length > 0) {
          setData(modalData);
          setShowModal(true);
        }
      } catch (error) {
        console.error('Error fetching notifications:', error);
      }
    };
    fetchData();
  }, []);

  useEffect(() => {
    if (showModal) {
      const modalElement = document.getElementById('exampleModalToggle');
      const modal = new window.bootstrap.Modal(modalElement);
      modal.show();
    }
  }, [showModal]);

  return (
    <>
      {data.length > 0 && (
        <div
          className="modal fade"
          id="exampleModalToggle"
          aria-hidden="true"
          aria-labelledby="exampleModalToggleLabel"
          tabIndex="-1"
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div id="modalH" className="carousel slide" data-bs-ride="carousel">
                <div className="carousel-inner">

                  {data.map((item, index) => {
                    const hasImage = item?.image?.[0];
                    const hasAttachment = item?.attachments?.[0];
                    return (
                      <div
                        key={index}
                        className={`carousel-item${index === 0 ? ' active' : ''}`}
                      >
                        <div className="modal-header">
                          <h1>{item.title || 'Notification Title'}</h1>
                          <button
                            type="button"
                            className="btn-close btn-close-white"
                            data-bs-dismiss="modal"
                            aria-label="Close"
                          ></button>
                        </div>
                        <div className="modal-body">
                          <div className="card modalcard">
                            <div className="row">
                              <div className="card-body">
                                {hasImage && (
                                  <img
                                    src={`https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/${item.image[0]}`}
                                    className="img-fluid"
                                    alt={item.title || 'Notification Image'}
                                  />
                                )}
                                <p>{item.description  || 'No description available.'}</p>
                                <div className="d-grid gap-2 d-md-flex justify-content-center mt-3">
                                  {hasAttachment && (
                                    <a
                                      href={`https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/${item.attachments[0]}`}
                                      className="btn btn-secondary btn-sm"
                                      target="_blank"
                                      rel="noopener noreferrer"
                                    >
                                      Attachment
                                    </a>
                                  )}
                                  {item.url && (
                                    <a
                                      href={item.url}
                                      className="btn btn-secondary btn-sm"
                                      target="_blank"
                                      rel="noopener noreferrer"
                                    >
                                      {item.urlTitle || 'Click Here'}
                                    </a>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  })}

                </div>

                {/* Carousel Controls */}
                <button
                  className="carousel-control-prev"
                  type="button"
                  data-bs-target="#modalH"
                  data-bs-slide="prev"
                >
                  <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                  <span className="visually-hidden">Previous</span>
                </button>
                <button
                  className="carousel-control-next"
                  type="button"
                  data-bs-target="#modalH"
                  data-bs-slide="next"
                >
                  <span className="carousel-control-next-icon" aria-hidden="true"></span>
                  <span className="visually-hidden">Next</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Popup;
